import { SkeletonBox } from "@ui/components/Skeleton";

function MessageGroupSkeleton({ width }: { width: string }) {
  return (
    <div className="flex items-end gap-3">
      <SkeletonBox className="size-10 shrink-0" rounded="full" />
      <div className="flex flex-col gap-1.5">
        <SkeletonBox className="h-4 w-24" />
        <SkeletonBox className={`h-12 ${width} rounded-2xl`} />
      </div>
    </div>
  );
}

export function ConversationDetailSkeleton() {
  return (
    <div className="flex flex-1 flex-col gap-5 overflow-y-auto p-4">
      <MessageGroupSkeleton width="w-64" />
      <MessageGroupSkeleton width="w-48" />
      <MessageGroupSkeleton width="w-56" />
    </div>
  );
}
